import { useNavigate } from "react-router-dom";
import { Host_APIS } from "../../../libs/apis/host.api";
import { successToaster } from "../../../utils/helpers/common/alert-service";
import { HostProfileDTO } from "../../../utils/helpers/models/host-dtos/host-profile.dto";
import { useState } from "react";
import useAuth from "containers/auth/useHooks";
import useStore from "hooks/useStore";
import { siteRoutes } from "utils/helpers/enums/routes";

const useHook = () => {
  const navigate = useNavigate();
  const [hostProfile, setHostProfile] = useState<HostProfileDTO | null>(null);
  const {getUserProfile} = useAuth();
  const { updateProfileCompletionStatus } = useStore();


  const uploadFile = async (params: FormData): Promise<{ id?: number; error?: string } | null> => {
    try {
      const response = await Host_APIS.uploadFile(params);
      const { status = false, message = "", data = null } = response || {};

      if (status && data) {
        // successToaster(message);
        return data;
      }

      // Return error message if available
      return { error: message || "Upload failed" };
    } catch (error: any) {
      console.error("Upload failed", error);
      const errorMessage = error?.response?.data?.message || error?.message || "Upload failed";
      return { error: errorMessage };
    }
  };

  const updateProfile = async (body: HostProfileDTO, goNext: Function, formData: HostProfileDTO, setOldFormData: Function) => {
    const response = await Host_APIS.postUserData(body);
    const { status = false, message = "" } = response || {};
    if(status){
      goNext();
      successToaster(message);
      setOldFormData({...formData});
      getUserProfile();
      
      // Update profileCompleted to true in localStorage for user profile
      // updateProfileCompletionStatus('host');
    }
  };

  const updateBusinessProfile = async (body: HostProfileDTO) => {
    const response = await Host_APIS.postBusinessProfileData(body);
    const { status = false, message = "" } = response || {};
    if(status){
      successToaster(message);
      getUserProfile();
      
      // Update profileCompleted to true in localStorage
      updateProfileCompletionStatus('host');
      
      navigate(siteRoutes.home);
    }
  };

  const getHostProfileData = async () => {
    const response = await Host_APIS.getHostProfileData();
    const { status = false, message = "" } = response || {};

    if (status) {
      setHostProfile(response?.data);
      return response.data;
    }
  };

  return {
    uploadFile,
    updateProfile,
    updateBusinessProfile,
    getHostProfileData,
    hostProfile,
  };
};

export default useHook;
